import React from 'react';
import { useState, useEffect } from 'react';
// import './bootstrap.min.css';
import './App3.css'
import './App2.css'
import Cookies from 'js-cookie';
import Login from './components/login.component';
import Home from './components/home.component';
import Profiles from './components/profiles.component';
import Me from './components/me.component';
import "./components/styles/animate.css"
import Axios from 'axios';


const App = () => {
  const [active, setActive] = useState('Home');
  const [isLogin, setIsLogin] = useState(false);
  const [name, setName] = useState(null);
  const [password, setPassword] = useState(null)
  const [userID, setUserID] = useState(null);
  const [homeContent, setHomeContent] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [firstHome, setFirstHome] = useState(false);
  const [changeSpinner, setChangeSpinner] = useState(false);
  const [myProfile, setMyprofile] = useState(
    { _id: 1, imageString: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTJtrD4PF2tjAQsN1JUZ_RwyacvCTN6V7O4zR3wATwy3FdyNSXf&usqp=CAU', name: '.......', about: '.....', followers: [] }
  );
  const [showNotification, setShowNotification] = useState(false);
  const [suffle, setSuffle] = useState(false);
  // const [submit,setSubmit] = useState(false);
  useEffect(() => {
    const name_ = Cookies.get('name');
    const password_ = Cookies.get('password');
    const islogintemp = Cookies.get('islogintemp');
    const userID_ = Cookies.get('userID');
    const seen = Cookies.get('seen');
    if (typeof seen != 'undefined') {
      setShowNotification(false);
    } else {
      setTimeout(() => {
        setShowNotification(true)
      }, 2000);
    }
    if (name_ && password_ && userID_) {
      setName(name_);
      setPassword(password_);
      setUserID(userID_);
    }
    if (islogintemp || userID_) {
      setIsLogin(true);
    }
    Axios.get('https://conffesion.herokuapp.com/home/' + name + "/" + password)
      .then(res => {
        let temp = res.data.POSTS;
        for (let i = 0; i < temp.length; i++) {
          temp[i]['liked'] = false;
          for (let j = 0; j < temp[i].userWhoLiked.length; j++) {
            if (temp[i].userWhoLiked[j] === userID_)
              temp[i]['liked'] = true;
          }
        }

        setFirstHome(true)
        setHomeContent(temp);
        // setHomeContent(res.data.POSTS)
        // console.log(res.data.POSTS)
      }).catch(err => { });

  }, []);


  const renderActive = (active, isLogin, homeContent) => {
    if (active === 'Home') {
      return (<Home homeContent={homeContent} userID={userID} likeHandler={likeHandler} />);
    }
    else if (active === 'Me') {
      if (isLogin) {
        if (myProfile._id == 1) {
          //Axios
          // setChangeSpinner(true)
          Axios.post("https://conffesion.herokuapp.com/myProfile", { userID: userID })
            .then(res => {
              setMyprofile(res.data.myProfile);
              setChangeSpinner(false)
            })
            .catch(err => { });
        }
        if (myProfile._id != 1)
          return (

            <div className='card'>

              {/* <h6> You are Logged in as: {name}</h6> */}
              <Me myProfile={myProfile} userID={userID} />

              <p style={{ fontSize: 'xx-small' }}>(Your feeds are automatically arranged according to your activities)</p>

            </div>)
        else {
          return (<div></div>)
        }
      } else {
        return (<Login setIsLogin={setIsLogin} />)
      }
    }
    else if (active === 'People') {
      return (
        <div>

          <Profiles profiles={profiles} userID={userID} />
        </div>
      )
    }
    else if (active === 'Match') {
      return (<div>
        <div className='card'>

          {/* <h6> You are Logged is as: {name}</h6> */}

          <img src='https://res.cloudinary.com/rupamcloud/image/upload/v1586004492/flinglogo_gjxnxz.png' className="img-fluid flingBig" ></img>
          <p className='promo'>---powered by Fling <img src='https://res.cloudinary.com/rupamcloud/image/upload/v1586004492/flinglogo_gjxnxz.png' className="img-fluid fling" ></img>(coming soon..)</p>
          <p className='aurin'>-Aurin</p>
          <a href='https://www.instagram.com/rupamj_das/'><span className='insta'></span></a>
          <p className='admin'>created by- <a href='https://www.instagram.com/rupamj_das/'>Rupam jyoti Das</a></p>
        </div>
      </div>)
    }
  }
  const loadProfile = () => {
    if (profiles.length <= 1 && typeof userID != 'undefined') {
      setChangeSpinner(true)
      setActive('')
      Axios.get('https://conffesion.herokuapp.com/profiles')
        .then(res => {
          let temp = res.data.profiles;
          for (let i = 0; i < temp.length; i++) {
            temp[i]['followed'] = false;
            for (let j = 0; j < temp[i].followers.length; j++) {
              if (userID === temp[i].followers[j]) {
                temp[i]['followed'] = true;
                console.log('hiii')
              }
            }

          }
          setProfiles(temp.reverse())
          setChangeSpinner(false);
          // setProfiles(res.data.profiles)
          setActive('People');

        })
    } else {
      //randomize
      let temp = profiles.sort((p, q) => { return q.followers.length - p.followers.length })
      // console.log(temp)
      setProfiles(temp);
      setActive('People');
    }
  }
  const rearrange = () => {
    let temp = homeContent;
    let filterd = temp.sort((v) => {
      if (typeof v.userWhoLiked.find(f => f == userID) != 'undefined') {
        return 2;
      }
      if (v.userID == userID)
        return -1;
      else {
        return typeof v.followers.find((f) => f === userID) == 'undefined' ? 1 : 0;
      }
    });
    setHomeContent(filterd);
  }

  const loadHome = () => {
    if (true) {
      let temp = homeContent;
      for (let i = 0; i < temp.length; i++) {
        temp[i]['liked'] = false;
        for (let j = 0; j < temp[i].userWhoLiked.length; j++) {
          if (temp[i].userWhoLiked[j] === userID)
            temp[i]['liked'] = true;
        }
      }
      setFirstHome(true)
      setHomeContent(temp);
      rearrange()
    }
    setActive('Home')
  }
  const likeHandler = (_id) => {
    let temp = homeContent;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i]._id === _id) {
        temp[i].userWhoLiked.push(userID)
        temp[i]['liked'] = true;
      }
    }
    setHomeContent(temp);
  }

  const mode = () => {
    // document.getElementById('blacks').style.background = 'black';
    // alert('hiii')

  }
  const onSeenNotification = () => {
    setShowNotification(false);
    Cookies.set('seen', 1, { expires: 100 });
  }
  useEffect(() => {
    if (active == 'Home') {
      let temp = homeContent.sort(() => 0.5 - Math.random());
      setHomeContent(temp);
    }
    if (active == 'People') {
      let temp = profiles.sort(() => 0.5 - Math.random());
      setProfiles(temp);
    }
  }, [suffle]);

  return (
    <div>


      <div className='d-flex'>
        <div className='p-2 ml-auto'><span className='logo' onClick={() => { mode(); }}></span></div>
        <div className='p-2 flex-fill'><h5 className='mainTitle'>Confessions</h5></div>
        <div className='p-2'> <span className='suffle' style={{ margin: '0.5rem' }} onClick={() => { setSuffle(!suffle) }}></span></div>
      </div>
      {showNotification ? (<div class="alert alert-success alert-dismissible animated tada">
        <button type="button" class="close" data-dismiss="alert" onClick={() => { onSeenNotification() }}>&times;</button>
        <strong>Make it App!</strong>Click the upper right corner of your browser and select "Add to home Screen".
        It will become an APP!
      </div>) : (
          ''
        )}
      <div className="nvr">
        <div className="d-flex p-1">
          <div className="p-2 "> <button className='btn btn-default' onClick={() => { loadProfile() }}><strong>{active === 'People' ? <span className='peopleicon'></span> : <span className='peopleicon'></span>}</strong></button></div>
          <div className="p-2 "> <button className='btn btn-default' onClick={() => loadHome()}><strong>{active === 'Home' ? <span className='homeIcon'></span> : <span className='homeIcon'></span>}</strong></button></div>
          {/* <div className="p-2 "> <button className='btn btn-default' onClick={() => setActive('Match')}>{active === 'Match' ? "/Match/" : 'Match'}</button></div> */}
          <div className="p-2 "> <button className='btn btn-default' onClick={() => { setActive('Me'); if (isLogin) setChangeSpinner(true); }}><strong>{active === 'Me' ? <span className='meIcon'></span> : <span className='meIcon'></span>}</strong></button></div>
          <div className='p-2' onClick={() => setActive('Match')} > <img src='https://res.cloudinary.com/rupamcloud/image/upload/v1586004492/flinglogo_gjxnxz.png' className="img-fluid fling" ></img>
          </div>
        </div>

      </div>

      <div className='container-fluid'>

      </div>

      <div className='display'>
        {changeSpinner ? (
          <div className="gooey">
            <span className="dot"></span>
            <div className="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : ('')}



        {renderActive(active, isLogin, homeContent)} {/* look at bottom*/}
      </div>
    </div>
  )
}


export default App;